import {
  SelectEditorDescription_FooterType,
  type SelectEditorDescription_Footer,
} from "@smartsuite/automation-engine-api";
import { RefreshFooter } from "./RefreshFooter";
import type { ActionCandidate } from "../../../../../../types/candidate";

export const Footer: React.FC<{
  handleClose: () => void;
  config: SelectEditorDescription_Footer | undefined;
  action?: ActionCandidate;
}> = ({ config, handleClose, action }) => {
  switch (config?.type) {
    case SelectEditorDescription_FooterType.REFRESH:
      return <RefreshFooter action={action} handleClose={handleClose} />;
    default:
      return null;
  }
};
